import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, Link } from 'react-router-dom';
import { RoutedTabs, NavTab } from "react-router-tabs";
import './App.css';
import axios from 'axios';
import UserProvider from "./providers/UserProvider";
import Chatbot from './pages/chatbot';
import { logOut } from "./firebase/firebase";
import HomePage from './pages/home';
import LoginPage from './pages/login';
import tutorProfileSetupPage from './pages/tutorProfileSetup';
import studentProfileSetupPage from './pages/studentProfileSetup';
import ReservePage from './pages/reserve';
import Page404 from './pages/Page404';
import FAQPage from './pages/faq';
import tutorTablePage from './pages/tutorTable';
import tutorProfilePage from "./pages/tutorProfile";
import studentProfilePage from "./pages/studentProfile";
import shortTransactionsPage from "./pages/shortTransaction";
import { useHistory} from 'react-router-dom';
import tutorProfileEditPage from "./pages/tutorProfileEdit";

function App() {
  const history = useHistory();
  console.log(localStorage.getItem('mode'));


    function delete_channels()
    {
        //const user = useContext(UserContext);//take email out of parameters
        //const {email} = user;
        var myParams = {
            username: localStorage.getItem('email'),
        }
        console.log(myParams);
        axios.post("https://auxilliabackend.herokuapp.com/logout",myParams)
            .then(function (response) {
            })
            .catch(function (error) {
                console.log(error);
            });
    }

  

  if(localStorage.getItem('mode') == 'none')
  {
    console.log("hello none");
    return (
      <div>
       <UserProvider>
       <Router >
       <NavTab to="/home">Home</NavTab>
       <NavTab to="/login">Login</NavTab>
       {/* <NavTab to="/tutorProfileSetup">Tutor Profile</NavTab> */}
       {/* <NavTab to="/reserve">Reserve</NavTab> */}
       <NavTab to="/faq">FAQ</NavTab>
         <Switch>
           <Route exact path="/404" component={Page404} />
           <Route exact path="/" >
             <Redirect to="/login"/>
           </Route>
           <Route exact path="/login" component={LoginPage} />
           <Route exact path="/faq" component={FAQPage} />
           <Redirect to="/login"/>
           <Route exact path="/tutorProfileSetup" component={tutorProfileSetupPage} />
           <Route exact path="/studentProfileSetup" component = {studentProfileSetupPage} />
           <Route exact path="/reserve" component={ReservePage} />
           <Route exact path = "/tutorTable" component = {tutorTablePage} />
           <Route exact path="/chats" component={Chatbot} />
           <Route exact path="/home" component={HomePage} />           

           <Redirect to="/404"/>
         </Switch>
        
       </Router>
       </UserProvider>
       <footer>
         <p>Contact us at jeffauxillium@gmail.com</p>
       </footer>
       </div>
       
     );
  }
  else if (localStorage.getItem('mode') === 'tutor')
  {
    return (
      <div>
       <UserProvider>
       <Router >
       {/* <NavTab to="/home">Home</NavTab> */}
       <button class = "logoutButton" onClick={() => {localStorage.setItem('mode','none');logOut();window.location.reload(true);}}>Logout</button>
       {/* <NavTab to="/reserve">Reserve</NavTab> */}
       <NavTab to="/faq">FAQ</NavTab>
       {/* <NavTab to="/home">Home</NavTab> */}
       {/* <NavTab to="/tutorTable">Tutor Table</NavTab> */}
       {/* <NavTab to = "/tutorProfile">Tutor Profile</NavTab> */}
       <NavTab to = "/chats">Chat</NavTab>
       {/* <NavTab to="/tutorProfileSetup">Edit Profile</NavTab> */}
       <NavTab to="/tutor/myprofile">Profile</NavTab>
         <Switch>
           <Route exact path="/404" component={Page404} />
           <Route exact path="/" >
             <Redirect to="/chats"/>
           </Route>
           {/* <Route exact path="/home" component={HomePage} /> //took out the home button because it is not needed */}
           {/* <Route exact path="/home" component={HomePage} /> */}
           <Route exact path="/tutorProfileSetup" component={tutorProfileSetupPage} />
           <Route exact path="/login" component={LoginPage} />
           {/* <Route exact path="/studentProfileSetup" component = {studentProfileSetupPage} />
           <Route exact path="/reserve" component={ReservePage} /> */}
           <Route exact path="/faq" component={FAQPage} />
           <Route exact path="/chats" component={Chatbot} />
           <Route exact path = "/tutor/MyProfile" component = {tutorProfileEditPage} />
           <Route exact path = "/tutorProfile" component = {tutorProfilePage} />
           <Redirect to="/404"/>
         </Switch>
        
       </Router>
       </UserProvider>
       
       </div>
    );
  }
  else if (localStorage.getItem('mode') == 'student')
  {
    return (
      <div>
       <UserProvider>
       <Router >
       <button  class = "logoutButton" onClick={() => {localStorage.setItem('mode','none');delete_channels();logOut();window.location.reload(true);}}>Logout</button>
       <NavTab to="/home">Home</NavTab>
       {/* <NavTab to="/tutorProfileSetup">Tutor Profile</NavTab> */}
       {/* <NavTab to="/reserve">Reserve</NavTab> */}
       <NavTab to="/studentProfile">Profile</NavTab>
       <NavTab to="/faq">FAQ</NavTab>
       {/* <NavTab to="/tutorTable">Tutor Table</NavTab> */}
       {/* <NavTab to = "/tutorProfile">Tutor Profile</NavTab> */}
       {/* <NavTab to = "/chats">Chat</NavTab> */}
       
         <Switch>
           <Route exact path="/404" component={Page404} />
           <Route exact path="/" >
             <Redirect to="/home"/>
           </Route>
           <Route exact path="/home" component={HomePage} />
           <Route exact path="/studentProfileSetup" component = {studentProfileSetupPage} />
           <Route exact path="/reserve" component={ReservePage} />
           <Route exact path="/faq" component={FAQPage} />
           <Route exact path="/login" component={LoginPage} />
           <Route exact path="/chats" component={Chatbot} />
           <Route exact path = "/tutorTable" component = {tutorTablePage} />
           <Route exact path = "/tutorProfile" component = {tutorProfilePage} />
           <Route exact path = "/shortTransaction" component = {shortTransactionsPage} />
           <Route exact path = "/studentProfile" component = {studentProfilePage} />
           <Redirect to="/404"/>
         </Switch>
        
       </Router>
       </UserProvider>
       
       </div>
    );
  }
  else
  {
    localStorage.setItem('mode','none');
  }
}

export default App;
